import { HierarchyLevelType } from 'common/interfaces/hierarchy-entities';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { getParentHierarchyEntityType } from 'client/views/explore/hierarchy/hierarchy.utils';
import { countriesFailed, countriesRequested, countryRecieved } from '../country/country';
import { fieldRecieved, fieldsFailed, fieldsRequested } from '../field/field';
import { HIERARCHY_ENTITIES_INFO } from '../../hierarchy-state-slice-factory';
import { siteRecieved, sitesFailed, sitesRequested } from '../site/site';
import { wellRecieved, wellsFailed, wellsRequested } from '../well/well';
import { wellboreRecieved, wellboresFailed, wellboresRequested } from '../wellbore/wellbore';
import { designRecieved, designsFailed, designsRequested } from '../design/design';

export const HIEARARCHY_API_ACTION_TYPES: { [index: string]: any; } = {
  [HierarchyLevelType.Country]: {
    startType: countriesRequested.type, 
    errorType: countriesFailed.type, 
    responseType: countryRecieved.type,
  },
  [HierarchyLevelType.Field]: {
    startType: fieldsRequested.type, 
    errorType: fieldsFailed.type, 
    responseType: fieldRecieved.type,
  },
  [HierarchyLevelType.Site]: {
    startType: sitesRequested.type, 
    errorType: sitesFailed.type, 
    responseType: siteRecieved.type,
  },
  [HierarchyLevelType.Well]: {
    startType: wellsRequested.type, 
    errorType: wellsFailed.type, 
    responseType: wellRecieved.type,
  },
  [HierarchyLevelType.Wellbore]: {
    startType: wellboresRequested.type, 
    errorType: wellboresFailed.type, 
    responseType: wellboreRecieved.type,
  },
  [HierarchyLevelType.Design]: {
    startType: designsRequested.type, 
    errorType: designsFailed.type, 
    responseType: designRecieved.type,
  },
};

export const getHierarchyEntityChainAPICallAction = (entityId: string, entityType: HierarchyLevelType, onAfterSuccessCallback?: (loadedEntityId: any, type: HierarchyLevelType) => void) => {
  const actions = HIEARARCHY_API_ACTION_TYPES[entityType];
  if (!actions) return () => null;
  return apiCallBegan({
    url: `/archive/${entityId}?type=${entityType}`,
    method: 'GET',
    onStart: () => ({ type: actions.startType, payload: { parentId: '' } }),
    onSuccess: (response: any) => ({ type: actions.responseType, payload: response }),
    onAfterSuccess: (response: any) => {
      const parentType = getParentHierarchyEntityType(entityType);
      if (!parentType) return;
      const { idProp } = HIERARCHY_ENTITIES_INFO[parentType];
      const loadedEntityId = response[idProp];
      if (!loadedEntityId) return;
      onAfterSuccessCallback?.(loadedEntityId, parentType);
      return getHierarchyEntityChainAPICallAction(loadedEntityId, parentType, onAfterSuccessCallback);
    },
    onError: (e: any) => ({ type: actions.errorType, payload: { parentId: '', message: e.message } }),
  });
};
